import { getConversationById } from '@app/helpers'
import { Conversation } from '@app/models'

import { ChatState } from '../types'

export const onBackgroundConversationUpdateSuccess = (
  state: ChatState,
  payload: Conversation
): ChatState => {
  const conversation = getConversationById(state.conversations, payload.id)
  if (!conversation) {
    return state
  }

  const {
    fullSubject,
    leadId,
    reference,
    source,
    subject,
    context,
    suggestedActions,
    updateDate,
  } = payload

  return {
    ...state,
    conversations: {
      ...state.conversations,
      [conversation.id]: {
        ...conversation,

        fullSubject,
        leadId,
        reference,
        source,
        subject,
        context,
        suggestedActions: suggestedActions ?? conversation.suggestedActions,
        updateDate: updateDate ?? conversation.updateDate,

        updating: 'SUCCEED',
      },
    },
  }
}
